import { render, staticRenderFns } from "./showUser.vue?vue&type=template&id=1755fc35&scoped=true"
import script from "./showUser.vue?vue&type=script&lang=js"
export * from "./showUser.vue?vue&type=script&lang=js"
import style0 from "./showUser.vue?vue&type=style&index=0&id=1755fc35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1755fc35",
  null
  
)

export default component.exports